import React from 'react';

const LoadingIndicator = () => (
  <div>
    加载中...
  </div>
);

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.tsx